var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-captcha"},[_c('div',{ref:"widget"}),(_vm.hasFailed)?_c('span',{staticClass:"contact-captcha__error"},[_vm._v(" "+_vm._s(_vm.$translate('components.contactCaptcha.unavailable'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }